import { render, staticRenderFns } from "./SummaryRowsTable.vue?vue&type=template&id=4835d8f5&scoped=true&"
import script from "./SummaryRowsTable.vue?vue&type=script&lang=js&"
export * from "./SummaryRowsTable.vue?vue&type=script&lang=js&"
import style0 from "./SummaryRowsTable.vue?vue&type=style&index=0&id=4835d8f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4835d8f5",
  null
  
)

export default component.exports